import request from "./request";

// 获取合作社 头部 统计数据
export function getCooperativeStatics(params) {
  return request
    .get("/largeScreen/cooperation/getCount", params)
    .then((res) => res);
}

// 合作社大屏-各类型合作社分布数量统计
export function getAreaCount(params) {
  return request
    .get("/largeScreen/cooperation/getAreaCount", params)
    .then((res) => res);
}

//  合作社大屏-合作社作业量统计
export function getJobAmountList(params) {
  return request
    .get("/largeScreen/cooperation/getJobAmountList", params)
    .then((res) => res);
}
// 合作社大屏-各类型合作社分布数量统计
export function getTypeCountByArea(params) {
  return request
    .get("/largeScreen/cooperation/getTypeCountByArea", params)
    .then((res) => res);
}
// 合作社大屏-查询合作社点位列表
export function getPointListByRadius(params) {
  return request
    .get("/largeScreen/cooperation/getPointListByRadius", params)
    .then((res) => res);
}
// 获取合作社能力列表
export function getCooperationCapability(params) {
  return request
    .get("../cooperative/seasonal/select/capability", params)
    .then((res) => res);
}
// 合作社大屏-合作社数量同环比
export function getCountRatio(params) {
  return request
    .get("/largeScreen/cooperation/getCountRatio", params)
    .then((res) => res);
}

// 合作社大屏-合作社烘干中心、应急服务队数量统计
export function getDryingEmergencyCount(params) {
  return request
    .get("/largeScreen/cooperation/getDryingEmergencyCount", params)
    .then((res) => res);
}

// 合作社大屏-合作社实时地块信息列表
export function getCooperationPlotList(params) {
  return request
    .get("/largeScreen/cooperation/getCooperationPlotList", params)
    .then((res) => res);
}

// 合作社大屏-查询合作社地块详情
export function getPlotInfoById(plotId) {
  return request
    .get("/largeScreen/cooperation/getPlotInfoById/" + plotId)
    .then((res) => res);
}

// 合作社大屏-查询合作社详情
export function getCooperationInfo(cooperationId) {
  return request
    .get("/largeScreen/cooperation/getCooperationInfo/" + cooperationId)
    .then((res) => res);
}

// 合作社大屏-查询合作社点位列表
export function getPointList(params) {
  return request
    .get("/largeScreen/cooperation/getPointList", params)
    .then((res) => res);
}

// 合作社大屏-查询合作社大屏地图地块列表
export function getPlotListByCooperation(params) {
  return request
    .get("/largeScreen/cooperation/getPlotListByCooperation", params)
    .then((res) => res);
}

// 获取类型
export function getJobType(params) {
  return request.get("/largescreen/job/getJobType", params).then((res) => res);
}
